import { Gauge } from "lucide-react";
import type { ModuleSpec } from "../types";

export const customerScoringSpec: ModuleSpec = {
  id: "customer-scoring",
  icon: Gauge,
  i18n: {
    namespace: "modules",
    titleKey: "customer-scoring.title",
    descriptionKey: "customer-scoring.description",
  },
  nav: {
    path: "/customers/scoring",
    group: "observe",
    order: 85,
    subgroup: "cdp",
  },
  permission: {
    action: "read",
    subject: "cdp",
  },
  meta: {
    status: "active",
    description: "Score plans that compute engagement, VIP likelihood, and other signals",
  },
};
